module.exports = __webpack_public_path__ + "img/microscoop.06802377.jpg";